export const bankLists = [
  {
    bank_code: "632005",
    bank_name: "Absa Bank Limited",
    icon: "ABSA",
  },
  {
    bank_code: "470010",
    bank_name: "Capitec Bank Limited",
    icon: "CAPITEC",
  },
  {
    bank_code: "580105",
    bank_name: "Investec Bank Limited",
    icon: "INVESTEC",
  },
  {
    bank_code: "250655",
    bank_name: "First National Bank",
    icon: "FNB",
  },
  {
    bank_code: "580000",
    bank_name: "Standard Bank of South Africa",
    icon: "SBSA",
  },
  {
    bank_code: "198765",
    bank_name: "Nedbank Limited",
    icon: "NEDBANK",
  },
  {
    bank_code: "410506",
    bank_name: "African Bank Limited",
    icon: "AFB",
  },
  {
    bank_code: "678910",
    bank_name: "Discovery Bank",
    icon: "DISCOVERY",
  },
  {
    bank_code: "123456",
    bank_name: "Tyme Bank",
    icon: "TYME",
  },
  {
    bank_code: "462005",
    bank_name: "Bidvest Bank Limited",
    icon: "BIDVEST",
  },
  {
    bank_code: "588000",
    bank_name: "Bank Zero",
    icon: "BANKZERO",
  },
  {
    bank_code: "678000",
    bank_name: "Sasfin Bank Limited",
    icon: "SASFIN",
  },
  {
    bank_code: "173000",
    bank_name: "Old Mutual Limited",
    icon: "OLDMUTUAL",
  },
  {
    bank_code: "154531",
    bank_name: "Access Bank South Africa",
    icon: "ACCESS",
  },
  {
    bank_code: "491304",
    bank_name: "Mercantile Bank Limited",
    icon: "MERCANTILE",
  },
  {
    bank_code: "490240",
    bank_name: "RMB Private Bank",
    icon: "RMB",
  },
  {
    bank_code: "587831",
    bank_name: "Grindrod Bank Limited",
    icon: "GRINDROD",
  },
  {
    bank_code: "470159",
    bank_name: "UBank Limited",
    icon: "UBANK",
  },
  {
    bank_code: "431000",
    bank_name: "HBZ Bank Limited",
    icon: "HBZ",
  },
  {
    bank_code: "585036",
    bank_name: "Albaraka Bank Limited",
    icon: "ALBARAKA",
  },
  {
    bank_code: "678901",
    bank_name: "Mukuru",
    icon: "MUKURU",
  },
  {
    bank_code: "679001",
    bank_name: "Peach Payments",
    icon: "PEACH",
  },
  {
    bank_code: "679002",
    bank_name: "PayFast",
    icon: "PAYFAST",
  },
  {
    bank_code: "679003",
    bank_name: "Ozow (Instant EFT)",
    icon: "OZOW",
  },
  {
    bank_code: "679004",
    bank_name: "SnapScan",
    icon: "SNAPSCAN",
  },
];

// South African bank universal branch codes are 6-digit strings.
// The codes above are representative universal branch codes used for EFT/instant payments.
